import { Component } from '@angular/core';

@Component({
  selector: 'app-publication-rules',
  templateUrl: './publication-rules.component.html',
  styleUrls: ['./publication-rules.component.css'],
})
export class PublicationRulesComponent {}
